import { css } from '@emotion/react'
import { Button, SpacingToken } from '@livechat/design-system-react-components'

import { useOneClickPaymentContext } from '@/context/OneClickPayment'
import mediaQueries from '@/layout/media-queries'
import { useTypedDispatch, useTypedSelector } from '@/store/hooks'
import { acceptCharge } from '@/store/payment'
import {
  isPaymentPending,
  isProcessableCharge,
  isUpdatingBillingCycle,
} from '@/store/selectors'
import { TermsCopy } from './TermsCopy'

const wrapperCss = css`
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: center;
  gap: var(${SpacingToken.Spacing2}) var(${SpacingToken.Spacing4});

  ${mediaQueries.xsmallScreen(60)} {
    flex-direction: row;
    flex-flow: row wrap;
  }
`

const buttonWrapperCss = css`
  display: flex;
  gap: var(${SpacingToken.Spacing2});
`

const PurchaseModalFooter = () => {
  const dispatch = useTypedDispatch()
  const isPending = useTypedSelector(isPaymentPending)
  const isUpdating = useTypedSelector(isUpdatingBillingCycle)
  const isProcessable = useTypedSelector(isProcessableCharge)

  const { closeModal } = useOneClickPaymentContext()

  const handleDeclineCharge = () => {
    closeModal()
  }

  const handleConfirmPurchase = () => {
    dispatch(acceptCharge())
  }

  return (
    <div css={wrapperCss}>
      <TermsCopy />

      <div css={buttonWrapperCss}>
        <Button
          kind="secondary"
          disabled={isPending}
          onClick={handleDeclineCharge}
          data-test="ocp-cancel-button"
        >
          Cancel
        </Button>
        <Button
          kind="primary"
          disabled={!isProcessable || isUpdating}
          loading={isPending}
          loaderLabel="Processing"
          onClick={handleConfirmPurchase}
          data-test="ocp-confirm-and-install-button"
        >
          Confirm
        </Button>
      </div>
    </div>
  )
}

export default PurchaseModalFooter
